import {Province} from '../../provinces/province/province';

export class Municipality {
  id: string;
  name: string;
  province: Province;
}
